import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationType as SchemaIntegrationType } from '../schemas/IntegrationType';
import { type Mapping as SchemaMapping } from '../schemas/Mapping';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const SetIntegrationMappingSettingsContentType = 'application/json' as const;
export type SetIntegrationMappingSettingsRequest = SchemaMapping;
export type SetIntegrationMappingSettingsResponses = LinkCommonErrorResponses & {
    /**
     * @description Mapping settings updated successfully
     */
    '200': {};
};
export type SetIntegrationMappingSettingsResponseSuccess = undefined;
export type SetIntegrationMappingSettingsSearchParams = undefined;
export type SetIntegrationMappingSettingsPathParameters = {
    integration_type: SchemaIntegrationType;
};
export const SetIntegrationMappingSettingsUrl = '/integrations/settings/mapping/{integration_type}' as const;
export const SetIntegrationMappingSettingsMethod = 'POST' as const;
export const getSetIntegrationMappingSettingsUrl = (params: SetIntegrationMappingSettingsPathParameters) =>
    SetIntegrationMappingSettingsUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof SetIntegrationMappingSettingsPathParameters) => String(params[param])
    );
